import React from 'react';
import './CircleCursor.scss'

const CircleCursor = ({circleCursorRef, show}) => (

    <div id="circle-cursor" className={show ? 'show' : ''} ref={circleCursorRef}></div>
)

export default CircleCursor